module.exports = "dist/96f1c901c087fb64019f7665f7f8aca6.woff2";